import { twMerge } from 'tailwind-merge';
import React from 'react';

interface Props {
    color?: string;
    children: JSX.Element | JSX.Element[];
}

const Skeleton = ({ color = 'text-gray-200', children }: Props) => (
    <div className={twMerge('animate-fade flex gap-4', color)}>{children}</div>
);

Skeleton.Image = ({ className = '' }) => (
    <div className={twMerge('h-40 w-full rounded-sm bg-current', className)} />
);

Skeleton.Avatar = ({ className = 'rounded-full' }) => (
    <div className={twMerge('size-9 bg-current', className)} />
);

Skeleton.Icon = ({ className = 'size-4' }) => (
    <div className={twMerge('rounded-sm bg-current', className)} />
);

Skeleton.Title = ({ className = '' }) => (
    <div className={twMerge('h-3 rounded-sm bg-current', className)} />
);

Skeleton.Text = ({ className = '' }) => (
    <div className={twMerge('h-2.5 rounded-sm bg-current', className)} />
);

Skeleton.DateDivider = ({ className = '' }) => (
    <div className={twMerge('flex items-center gap-x-2', className)}>
        <Skeleton.Line />
        <Skeleton.Text className="w-24" />
        <Skeleton.Line />
    </div>
);

Skeleton.Paragraph = ({ isLarge = false }) => (
    <div className="flex flex-col gap-3">
        <div className="grid grid-cols-3 gap-4">
            <div className="col-span-2 h-2 rounded-sm bg-current" />
            <div className="col-span-1 h-2 rounded-sm bg-current" />
        </div>
        {isLarge ? (
            <div className="grid grid-cols-4 gap-4">
                <div className="col-span-1 h-2 rounded-sm bg-current" />
                <div className="col-span-1 h-2 rounded-sm bg-current" />
                <div className="col-span-2 h-2 rounded-sm bg-current" />
            </div>
        ) : null}
        <div className="grid grid-cols-5 gap-4">
            <div className="col-span-3 h-2 rounded-sm bg-current" />
        </div>
    </div>
);

Skeleton.Line = ({ className = '' }) => (
    <div className={twMerge('h-px w-full bg-current', className)} />
);

Skeleton.Image = ({ className = '' }) => (
    <div className={twMerge('size-full rounded-sm bg-current', className)} />
);

export default Skeleton;
